import { render, staticRenderFns } from "./BookingCancellationForm.vue?vue&type=template&id=8084608c&"
import script from "./BookingCancellationForm.vue?vue&type=script&lang=js&"
export * from "./BookingCancellationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports